import { useEffect, useState } from "react";
import { Notify } from "../../../../../utils/notify";
import { IConteudo } from "../../../../../Interfaces/model/IConteudo";
import { PurpleButton } from "../../../../../components/buttons/purpleButton";
import { ImageUpload } from "../../../../../components/imageUpload";
import { TextBox } from "../../../../../components/textBox";
import { ContentSummary, UpdateContentContainer } from "./styles";

interface Props {
  showDeleteContainer: boolean;
  arrayOfContent: IConteudo[];
  setArrayOfContent: (arrayOfContent: IConteudo[]) => void;
  selectedIndex: number;
  setSelectedIndex: (index: number) => void;
  isUploading?: boolean;
  onUploadingChange?: (isUploading: boolean) => void;
}

export const UpdateContent = ({
  selectedIndex,
  setSelectedIndex,
  arrayOfContent,
  showDeleteContainer,
  setArrayOfContent,
  isUploading = false,
  onUploadingChange,
}: Props) => {
  const [subtitleUpdated, setSubtitleUpdated] = useState<string>(
    arrayOfContent[selectedIndex].subtitulo
  );
  const [paragraphUpdated, setParagraphUpdated] = useState<string>(
    arrayOfContent[selectedIndex].paragrafo
  );
  const [imageUpdated, setImageUpdated] = useState<string | undefined>(
    arrayOfContent[selectedIndex].imagem
  );

  const [videoUpdated, setVideoUpdated] = useState<string | undefined>(
    arrayOfContent[selectedIndex].video
  );

  useEffect(() => {
    setSubtitleUpdated(arrayOfContent[selectedIndex].subtitulo);
    setParagraphUpdated(arrayOfContent[selectedIndex].paragrafo);
    setImageUpdated(arrayOfContent[selectedIndex].imagem);
    setVideoUpdated(arrayOfContent[selectedIndex].video);
  }, [arrayOfContent, selectedIndex]);

  const updateObject = () => {
    if (isUploading) {
      Notify.warning("Aguarde o envio da imagem antes de atualizar.");
      return;
    }

    if (paragraphUpdated !== "") {
      const updatedObject: IConteudo = {
        paragrafo: paragraphUpdated,
        subtitulo: subtitleUpdated,
        imagem: imageUpdated,
        video: videoUpdated,
      };

      const newArray = arrayOfContent.map((obj, i) => {
        if (i === selectedIndex) {
          return updatedObject;
        }
        return obj;
      });
      setArrayOfContent(newArray);
    } else {
      Notify.warning("O parágrafo deve ter algum conteúdo");
    }
  };

  if (arrayOfContent[selectedIndex].paragrafo !== undefined) {
    return (
      <UpdateContentContainer
        style={{ display: showDeleteContainer ? "grid" : "none" }}
      >
        <h1>Atualizar conteúdo</h1>
        <select
          value={selectedIndex}
          disabled={isUploading}
          onChange={(e) => setSelectedIndex(Number.parseInt(e.target.value))}
        >
          {arrayOfContent.map((content, index) => (
            <option key={index} value={index}>
              Bloco de conteúdo: {index + 1}
            </option>
          ))}
        </select>

        <ContentSummary>
          <TextBox
            height="fit-content"
            title="Subtítulo"
            maxLength={255}
            onChangeText={setSubtitleUpdated}
            value={subtitleUpdated}
          />
          <TextBox
            height="400px"
            title="Parágrafo"
            maxLength={3000}
            onChangeText={setParagraphUpdated}
            value={paragraphUpdated}
          />
          <ImageUpload
            key={selectedIndex}
            label="Imagem do conteúdo"
            category="CONTEUDO"
            onChange={setImageUpdated}
            value={imageUpdated ?? ""}
            onUploadingChange={onUploadingChange}
          />
          <TextBox
            height="fit-content"
            title="Link do vídeo"
            maxLength={255}
            onChangeText={setVideoUpdated}
            value={videoUpdated ?? ""}
          />
          <PurpleButton
            title="Atualizar conteúdo"
            disabled={isUploading}
            onClick={updateObject}
          />
        </ContentSummary>
      </UpdateContentContainer>
    );
  } else {
    return <div />;
  }
};
